
export default [
  {
    name: 'My Wells',
    path: '/wellManagement/myWells',
    component: (resolve) => require(['@/views/wellManage/myWells/index'], resolve),
    meta: { title: 'Well Management', noCache: false, affix: false },
    roles: [0, 3]
  },
  {
    name: 'AddWell',
    path: '/wellManagement/addWell',
    hidden: true,
    component: (resolve) => require(['@/views/wellManage/myWells/addWell'], resolve),
    meta: { title: 'Add a New Well', noCache: false, affix: false },
    roles: [0, 3]
  },
  {
    name: 'ModifyWell',
    path: '/wellManagement/modifyWell',
    hidden: true,
    component: (resolve) => require(['@/views/wellManage/myWells/modifyPage'], resolve),
    meta: { title: 'Modify Well information', noCache: false, affix: false },
    roles: [0, 3]
  },
  {
    name: 'WellDetail',
    path: '/wellManagement/wellDetail',
    hidden: true,
    component: (resolve) => require(['@/views/wellManage/myWells/details'], resolve),
    meta: { title: 'Well Information', noCache: false, affix: false },
    roles: [0, 3]
  },
  // {
  //   name:"AddNewWellPonit",
  //   path: '/wellManagement/addNewPoint',
  //   hidden:true,
  //   component: (resolve) => require(['@/views/wellManage/addWell/addPoint'], resolve),
  //   meta: { title: 'Add a New Well', noCache: false, affix: false },
  //   roles:[0]
  // },
  // {
  //   name:"AddNewWellWell",
  //   path: '/wellManagement/addNewWellWell',
  //   hidden:true,
  //   component: (resolve) => require(['@/views/wellManage/addWell/addWell'], resolve),
  //   meta: { title: 'Add a New Well', noCache: false, affix: false },
  //   roles:[0]
  // },
  // {
  //   name:"wellManagementAnnualReview",
  //   path: '/wellManagement/annualReview',
  //   hidden:true,
  //   component: (resolve) => require(['@/views/wellManage/annualReview/index'], resolve),
  //   meta: { title: 'Annual Review', noCache: false, affix: false },
  //   roles:[0,9]
  // },
  {
    name: 'ApprovalWell',
    path: '/wellManagement/approve',
    component: (resolve) => require(['@/views/wellManage/approveWells/index'], resolve),
    meta: { title: 'Approval of New Well', noCache: false, affix: false, checkAccount: true },
    roles: [1]
  },
  {
    name: 'ApprovalWellDetails',
    path: '/wellManagement/approve/details',
    component: (resolve) => require(['@/views/wellManage/approveWells/details'], resolve),
    hidden: true,
    meta: { title: 'Approval Details of New Well', noCache: false, affix: false, checkAccount: true },
    roles: [1]
  }
]
